import types from "./mutation-types";

const MUTATIONS = {
  /**
   * @param {Object} state
   * @param {Object} cmsData
   */
  [types.ADD_CMS_DATA](state, cmsData) {
    state.cms = cmsData;
  },

  /**
   * @param {Object} state
   * @param {Object} notificaitonData
   */
  [types.ADD_NOTIFICATION_DATA](state, notificaitonData) {
    state.notification = notificaitonData;
  },

  /**
   * @param {Object} state
   * @param {Object} region
   */
  [types.ADD_REGION](state, region) {
    if (state.regions.find(r => r.id === region.id)) {
      return;
    }

    state.regions.push(region);
  },

  /**
   * @param {Object} state
   * @param {Object} region
   */
  [types.SET_SELECTED_REGION](state, region) {
    state.selectedRegion = region;
  },

  /**
   * @param {Object} state
   * @param {Object} region
   */
  [types.CLEAR_SELECTED_REGION](state) {
    state.selectedRegion = {};
  },

  /**
   * @param {Object} state
   * @param {Object} observation
   */
  [types.SET_SELECTED_OBSERVATION](state, observation) {
    state.selectedObservation = observation;
  },

  /**
   * @param {Object} state
   * @param {Object} forecast
   */
  [types.ADD_FORECAST](state, forecast) {
    if (state.forecasts.find(f => f.id === forecast.id)) {
      return;
    }

    state.forecasts.push(forecast);
  },

  /**
   * @param {Object} state
   * @param {Object} recaptchaKey
   */
  [types.ADD_RECAPTCHA_KEY](state, recaptchaKey) {
    state.recaptcha = recaptchaKey;
  },

  /**
   * @param {Object} state
   * @param {Object} observation
   */
  [types.ADD_OBSERVATION](state, observation) {
    if (state.observations.find(o => o.id === observation.id)) {
      return;
    }

    state.observations.push(observation);
  },

  [types.SET_SHOW_RECENT_PUBLIC_OBS](state, show) {
    // reset date filters when recent changes to true/false
    if (show !== null) {
      state.observationsFilters = {
        ...state.observationsFilters,
        ...{ dateRange: false, dateFrom: `${new Date().getFullYear()}-01-01`, dateTo: null }
      };
    }
    state.showRecentPublicObs = show;
  },

  [types.CLEAR_OBSERVATIONS_FILTERS](state) {
    state.observationsFilters = {};
  },

  [types.UPDATE_OBSERVATIONS_FILTERS](state, filters) {
    state.observationsFilters = { ...state.observationsFilters, ...filters };
  }
};

export default MUTATIONS;
